import React from "react";

export default function Space({ count = 1 }: { count?: number }): React.JSX.Element {
  return <>{" ".repeat(count)}</>;
}
